var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9146 8.60464H11.3953V1.08527C11.3953 0.742735 10.9302 0 9.99996 0C9.06974 0 8.6046 0.742775 8.6046 1.08527V8.60468H1.08527C0.742772 8.60464 0 9.06977 0 9.99996C0 10.9301 0.742772 11.3953 1.08527 11.3953H8.60464V18.9147C8.60464 19.2572 9.06974 20 10 20C10.9303 20 11.3954 19.2572 11.3954 18.9147V11.3953H18.9147C19.2572 11.3953 20 10.9302 20 9.99996C20 9.06969 19.2571 8.60464 18.9146 8.60464Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusWhite);
export default __webpack_public_path__ + "static/media/plus-white.e4519fe5f90ec73ec82274993dcf75eb.svg";
export { ForwardRef as ReactComponent };